function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmmth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 1024.065,
    height: 1324.14,
    viewBox: "0 0 270.951 350.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M-10.229-18.863 1.218 165.541c5.26 16.062 24.281 19.563 37.829 27.292l212.79 103.07c15.656.316 5.655-18.947 6.608-27.858-3.508-31.484-5.95-63.135-10.539-94.475-11.359-12.094-30.623-15.38-44.996-24.08-18.833-8.873-37.672-17.736-56.502-26.613-7.707-9.91-4.57-23.17-6.52-34.8L129.54-40.67c-10.118-19.654-36.031-13.692-53.946-9.668-23.254 4.525-47.162 7.01-69.938 13.144C-3.301-33.89-5.747-25.85-10.23-18.863z",
    style: {
      fill: "#e0ca38",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.46285e-8,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(10.229 54.438)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 20.458,
    y: 161.103,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "35.2778px",
      fontFamily: "Arial",
      InkscapeFontSpecification: "Arial",
      fill: "#f9f9f9",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 7.9375e-9,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(10.229 54.438)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20.458,
    y: 161.103,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "35.2778px",
      fontFamily: "Arial",
      InkscapeFontSpecification: "Arial",
      fill: "#f9f9f9",
      strokeWidth: 7.9375e-9
    }
  }, "GMMTH")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmmth);
export default __webpack_public_path__ + "static/media/GMMTH.d6d9d5867f6090319e47eb5a3d0eb955.svg";
export { ForwardRef as ReactComponent };